import { KPITypesEnum } from '../../types';
import { DeviceFilterEnum } from '../FilterSection/DeviceSelector/types';
import { TimeRangeEnum } from '../FilterSection/TimeRangeSelector/types';

export interface DifferenceTextProps {
  diff: number;
}

export interface IKpiCardProps {
  kpiType: KPITypesEnum;
  kpiValue?: number;
  timeRange: TimeRangeEnum;
  product: string;
  device: DeviceFilterEnum;
  shopId: number;
}

export const KpiDescriptions: Record<KPITypesEnum, string> = {
  [KPITypesEnum.Impressions]: 'Unique sessions where a Syte interface was displayed to users.',
  [KPITypesEnum.Revenue]:
    'Syte-attributed revenue from direct and assisted purchases for the selected product scope.',
  [KPITypesEnum.ARPU]:
    'Average Revenue Per User — Syte-attributed revenue divided by Syte users for the selected product scope.',
  [KPITypesEnum.CTR]:
    'Click-Through Rate — offer-click sessions divided by product layout sessions. Discovery Button uses button-click sessions as its layout denominator.',
  [KPITypesEnum.CVR]:
    'Conversion Rate — Syte-attributed transactions divided by Syte users for the selected product scope.',
  [KPITypesEnum.AOV]:
    'Average Order Value — Syte-attributed revenue divided by Syte-attributed transactions for the selected product scope.',
};

export const KpiSigns: Record<KPITypesEnum, string> = {
  [KPITypesEnum.Impressions]: '',
  [KPITypesEnum.Revenue]: '$',
  [KPITypesEnum.ARPU]: '$',
  [KPITypesEnum.CTR]: '%',
  [KPITypesEnum.CVR]: '%',
  [KPITypesEnum.AOV]: '$',
};
